import React, { Fragment } from 'react';

import Hr from 'components/Shared/Hr/Hr';
import { breakpoints } from 'styles/cp';

export interface Props {
  children: React.ReactNode | string | null;
}

const RecurringNoticeWrapper: React.FC<Props> = ({ children }) => {
  return (
    <Fragment>
      <div className="wrapper">
        <Hr marginBottom={21} marginTop={16} />
        {children}
        <Hr marginBottom={24} marginTop={21} />
      </div>

      <style jsx>{`
        .wrapper {
          @media screen and (max-width: ${breakpoints.sm}) {
            padding: 0 20px;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default RecurringNoticeWrapper;
